import { ChangeEvent, useMemo, useState } from "react";
import useDebounce from "./useDebounce";

import { ICharacter, IResponse } from "../types";

const API_URL = "https://rickandmortyapi.com/api";
const CHARACTERS_URL = API_URL + "/character?page=1";

// eslint-disable-next-line
const useRickMortyAPI = (name: string) => {
  const [characters, setCharacters] = useState<Array<ICharacter>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurretPage] = useState<number>(1);
  const [url, setUrl] = useState<string>(CHARACTERS_URL);
  const [filter, setFilter] = useState<string>("");

  const debouncedValue = useDebounce(filter, 600);

  // All Character + Load More Button

  useMemo(async () => {
    setLoading(true);

    if (name === "GraphQL") {
      const res = await fetch("https://rickandmortyapi.com/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: `{
            characters(page: ${currentPage}) {
              results {
                name
                status
                species
                type
                gender
                origin {
                  name
                }
                location {
                  name
                }
                image 
                episode{
                  id
                }
                created
              }
            }
          }`
        })
      })
        .then(res => res.json())
        .then(res => {
          return res.data.characters.results;
        });

      let current = characters;
      current = [...current, ...res];
      setCharacters(current);
    } else if (name === "Rest") {
      const res = await fetch(url);
      let current = characters;
      const result = ((await res.json()) as IResponse).results;
      current = [...current, ...result];
      setCharacters(current);
      console.log(characters);
    }

    setLoading(false);
  }, [currentPage, url]);

  const handleNext = () => {
    console.log("Next");

    const nextPage = currentPage + 1;
    setCurretPage(nextPage);
    const urlPart = url.slice(0, 41);
    setUrl(`${urlPart}?page=${currentPage}`);
    console.log(currentPage);
  };

  // All Character + Filter by name
  useMemo(async () => {
    setLoading(true);

    if (name === "GraphQL") {
      try {
        const res = await fetch("https://rickandmortyapi.com/graphql", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            query: `{
                  characters${filter && `(filter: {name: "${filter}"})`} {
                    results {
                      name
                      status
                      species
                      type
                      gender
                      origin {
                        name
                      }
                      location {
                        name
                      }
                      image 
                      episode{
                        id
                      }
                      created
                    }
                  }
                }`
          })
        })
          .then(res => res.json())
          .then(res => {
            return res.data.characters.results;
          });

        setCharacters(res);
      } catch (err) {
        setCharacters([]);
      }
    } else {
      try {
        const res = await fetch(
          "https://rickandmortyapi.com/api/character?name=" + filter
        );
        const result = ((await res.json()) as IResponse).results;
        setCharacters(result);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    }

    setLoading(false);
  }, [debouncedValue]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const wrote = e.target.value;
    setFilter(wrote);
  };

  return { characters, loading, filter, handleChange, handleNext };
};

export default useRickMortyAPI;
